/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

export enum DpPalette {
	// Brand Colors
	SECONDARY_DEFAULT = '#FED536',
	SECONDARY_DARK = '#F6D454',
	SECONDARY_LIGHT = '#FFF9CE',

	PRIMARY_DEFAULT = '#774A91',
	PRIMARY_DARK = '#5E3582',
	PRIMARY_LIGHT = '#F5F0FF',

	// Text Colors
	TEXT_DEFAULT = '#2C2C2C',
	TEXT_DARK = '#020202',
	TEXT_LIGHT = '#FFFFFF',
	TEXT_OUT_OF_FOCUS = '#929292',

	// Button Colors
	BUTTON_PRIMARY = '#333333',
	BUTTON_PRIMARY_HOVER = '#222222',
	BUTTON_ACCENT = '#FF4900',
	BUTTON_UNFOCUSED = '#F1F1F1',
	BUTTON_DISABLED = '#727272',

	// Border Colors
	BORDER_DEFAULT = '#CBCACC',

	// Background Colors
	BACKGROUND_DEFAULT = '#FBFBFC',

	// Icons Colors
	ICON_DEFAULT = '#020202',

	// General Colors
	RED_DEFAULT = '#BF0000',
	RED_DARK = '#900005',

	GREEN_DEFAULT = '#0E8439',
	GREEN_DARK = '#458F03',

	YELLOW_LIGHT = '#FFF9CE',

	BROWN_DARK = '#79512F',

	BLACK_DEFAULT = '#000000',

	// Dp Colors
	DPPUNTOS_DEFAULT = '#D10D48',
	DPREWARDS_DEFAULT = '#774A91',
	DPREWARDS_LIGHT = '#E0F7FF',

	DIVIDER_DEFAULT = '#D9D9D9',

	HEADER_DEFAULT = '#FED536',
	HEADER_TEXT = '#000000',
}

export const palette: ThemeOptions = {
	palette: {
		primary: {
			main: DpPalette.PRIMARY_DEFAULT,
			dark: DpPalette.PRIMARY_DARK,
			light: DpPalette.PRIMARY_DEFAULT,
			contrastText: '#ffffff',
		},
		secondary: {
			main: DpPalette.SECONDARY_DEFAULT,
			light: DpPalette.SECONDARY_LIGHT,
			dark: DpPalette.SECONDARY_DEFAULT,
			contrastText: '#ffffff',
		},
		text: {
			main: DpPalette.TEXT_DEFAULT,
			primary: DpPalette.TEXT_DEFAULT,
			secondary: '#5e6977',
			disabled: '#b5beca',
			highlight: '#93101c',
			alert: '#c10c0d',
			expandedMenu: '#ffffff',
		},
		base: {
			main: '#43484d',
			contrastText: '#ffffff',
			iconDefault: DpPalette.ICON_DEFAULT,
			redDefault: DpPalette.RED_DEFAULT,
			redDark: DpPalette.RED_DARK,
			greenDefault: DpPalette.GREEN_DEFAULT,
			greenDark: DpPalette.GREEN_DARK,
			yellowLight: DpPalette.YELLOW_LIGHT,
			brownDark: DpPalette.BROWN_DARK,
			dpPuntosDefault: DpPalette.DPPUNTOS_DEFAULT,
			dpRewardsDefault: DpPalette.DPREWARDS_DEFAULT,
			dpRewardsLight: DpPalette.DPREWARDS_LIGHT,
		},
		action: {
			hover: 'rgba(119, 74, 145, 0.05)',
			disabled: '#b5beca',
			disabledBackground: '#ddcfcf',
		},
		background: {
			main: DpPalette.BACKGROUND_DEFAULT,
			default: DpPalette.BACKGROUND_DEFAULT,
			paper: '#ffffff',
			transparency: 'cc', // used to combine hex colors with transparency (00-ff), e.g., #ffffffcc
			contrastText: DpPalette.TEXT_DEFAULT,
			selectedStore: '#f4f4f4',
		},
		divider: DpPalette.DIVIDER_DEFAULT,
		border: {
			dark: '#4c5256',
			alert: '#c10c0d',
			footer: '#888',
		},
		textField: {
			border: DpPalette.RED_DEFAULT,
			borderHovered: DpPalette.RED_DEFAULT,
			background: '#fdfdfd',
			disabledBackground: '#ddcfcf',
		},
		button: {
			primary: DpPalette.BUTTON_PRIMARY,
			primaryHover: DpPalette.BUTTON_PRIMARY_HOVER,
			secondary: '#ffffff',
			secondaryHover: '#fff4f4',
			contrastText: '#fdfdfd',
			disabled: DpPalette.BUTTON_DISABLED,
			disabledText: DpPalette.TEXT_LIGHT,
		},
		header: {
			main: DpPalette.HEADER_DEFAULT,
			text: DpPalette.HEADER_TEXT,
		},
	},
} as ThemeOptions;
